import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChevronLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chevron_left"}/>
}
